import React from 'react';
import { MBEmptyListPlaceholder } from '@shared/components/list/emptyListPlaceholder';
import { i18n } from '@shared/util/i18n';

interface Props {
  keyword: string;
}

export function SearchEmpty({ keyword }: Props) {
  return (
    <MBEmptyListPlaceholder
      title={i18n('card.blocks.cardsInput.search.emptyState.title', { keyword })}
      description={i18n('card.blocks.cardsInput.search.emptyState.message')}
    />
  );
}
